"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  blExchangeAppointment: {
    blNoTips: '查询规则:提单号(最多10票)多票查询时用半角英文逗号隔开',
    blNoAndCode: '提单号/收货码：',
    blNoAndCode4PH: '提单号/验证码：',
    blNoCNXMNTips: '查询规则:提单号/收货码(最多20票)多票查询时用逗号隔开:提单号/收货码,提单号/收货码...',
    blNoPHTips: '查询规则:提单号/验证码',
    feeInquiry: '如有坏污箱费及超期费疑问，烦请发送邮件至 sitcsh_imp@sitc.com 咨询。',
    downloadBill: '如需下载账单，请预约后到换单预约历史中下载。',
    ApplicablePorts: '适用港口：CNSHK、CNTAO、CNTXG、CNXMN、PH、CNNGB',
    reserved: '已预约',
    reservationSaved: '预约已保存，在审核附件格式',
    notReserved: '未预约',
    reservationFailed: '预约失败',
    ownerType: '小提单拥有者类别',
    send: '已发送',
    exchangeRate: '汇率',
    invoiceAmount: '金额',
    totalAmount: '应收金额合计',
    totalInvoiceAmount: ',折合PHP',
    invoiceNo: '发票号',
    unSend: '未发送',
    authorized: '已授权',
    unauthorized: '未授权',
    cancellingAuth: '授权取消中',
    noPaid: '未付款',
    accounted: '已核账',
    reviewingAttachment: '附件格式正确，在审核水单金额',
    noDeliveryTime: '换单时间未维护不可进行授权操作',
    noDeliveryTime1: '换单时间未维护不可进行预约操作',
    noReservation: '未预约不可进行授权操作',
    customerNotice: '尊敬的进口客户：',
    confirmReservation: '烦请务必确认所要预约的提单，是否属于进口危化品（列入《危险化学品目录》2015版，但不受《国际海运危险品货物规则》限制）。',
    dangerousGoodsNotice: '如果属于危化品，请于船靠前48小时向我司申报。',
    declarationNotice: '请点击',
    downloadNotice: '《告客户书-关于进口危化品集装箱申报的通知》',
    download: '进行下载',
    downloadPrint: '下载',
    acknowledged: '我已知晓',
    manifestUnpaid: '舱单未付款，请付款后进行预约。',
    cannotChangeAccredit: '提单：{blNo} 已换单，无法修改授权信息。',
    confirmOriginalBl: '是否为正本提单？（确定为是，取消为否）',
    portReleasePending: '起运港还未通知电放或者SWB放货，无法预约',
    pleaseCheckData: '请勾选数据',
    checkSamePort: '请勾选相同的港口',
    fileSize: '文件大小不应超过10MB!',
    fileFormat: '可上传文件类型为PDF\\WORD\\JPG,大小限制在10M以内',
    attachmentFileLength: '水单文件名过长，请控制在40个字符内！',
    portMediaCodeFileLength: '介质码文件名过长，请控制在40个字符内!',
    notFileSelected: '未选择任何文件',
    No: '序号',
    blNoAndContainerNo: '提单号：',
    prompt: '查询规则:提单号/箱号(最多10票)',
    promptCondition: '多票查询时用逗号隔开:提单号/箱号,提单号/箱号...',
    searchResult: '查询结果',
    foreSpeakInfo: '预约信息',
    foreSpeakCost: '费用信息',
    outVesselCode: '出口船名',
    outVoyageNo: '出口航次',
    outVoyageLeg: '出口航段',
    inVesselCode: '进口船名',
    inVoyageNo: '进口航次',
    inVoyageLeg: '进口航段',
    pod: '卸货港',
    del: '目的地',
    blNo: '提单号',
    deliverableDate: '可换单日期',
    eta: '预计到港日期',
    edoSentStatus: 'EDO状态',
    edoSentStatusSh: '换单发送状态',
    accreditSentStatus: '授权发送状态',
    accreditStatus: '授权状态',
    accreditContact: '授权公司联系方式',
    accreditCompanyName: '授权公司名称',
    soaNo: '对账单号',
    chargeCode: '费项代码',
    currency: '币种',
    amount: '应收金额',
    containerType: '箱型',
    cargoType: '货类',
    foreSpeak: '预约申请',
    vesselCode: '船名',
    voyageNo: '航次',
    voyageLeg: '航段',
    containerNo: '箱号',
    freeTimeNo: 'F/T',
    pickUpDate: '提箱日期',
    promptText: '注意：查询OF（海运费），烦请发送邮件至sitcsh_imp@sitc.com,标明船名、航次、提单号，附上提单扫描件人民币开户银行：招商银行上海北外滩支行 人民币银行帐号：121908093010709',
    accreditCustomer: '授权客户',
    accredit: '授权',
    dem: 'DEM',
    dg: 'DG',
    startDate: 'Start Date',
    endDate: 'End Date',
    FreeUntil: 'Free Until',
    OverDay: 'Over Day',
    ftNo: 'F/T No.',
    confirmAmount: 'Amount',
    tax: 'Tax',
    commission: 'Commission',
    confirmCurrency: 'Currency',
    amount4PHP: 'AMOUNT IN PHP',
    forespeakCnngb: 'Appoint(宁波)',
    forespeakCntao: 'Appoint(青岛)',
    forespeakCnxmn: 'Appoint(厦门)',
    forespeakCntxg: 'Appoint(新港)',
    forespeakCnshk: 'Appoint(蛇口)',
    forespeakCommon: 'Appoint',
    pleaseInput: '请输入',
    select: "请选择",
    selectFile: '选择文件',
    voyageNoBlNo: '船名航次/提单号',
    paymentStatus: '付款状态',
    forespeakStatus: '预约状态',
    releaseStatus: '放单状态',
    doType: '提货单性质',
    electronicBill: '电子提货单',
    paperBill: '纸质提货单',
    paymentNo: '付款抬头',
    payDate: '付款日期',
    invoiceTitle: '发票抬头',
    paymentMethod: '付款方式',
    payType: '付款类型',
    bankSlip: '水单',
    portMediaCode: '介质码',
    mail: '邮箱',
    receiveEmail: '接收邮箱',
    identifier: '纳税人识别号',
    identifierXg: 'EDO接收方纳税人识别号',
    consigneeName: '收货人姓名',
    consigneeAddress: '收货人地址',
    address: '地址',
    phone: '电话',
    accountBank: '开户行',
    invoiceTaxNo: '发票抬头税号',
    invoiceBankNo: '发票抬头账号',
    powerAttorney: '开票委托书',
    blNoNotEmpty: '提单号不能为空！',
    portCodeEmpty: '港口不能为空！',
    invoiceTitleNotNull: '发票抬头不能为空',
    paymentMethodNotNull: '付款方式不能为空',
    emailNotNull: '邮箱不能为空',
    invalidEmail: '邮箱格式错误',
    bankSlipNotNull: '请上传水单!',
    portMediaCodeNotNull: '请上传介质码！',
    powerAttorneyNotNull: '请上传开票委托书',
    invalidPhone: '电话格式错误',
    phoneNotNull: '电话不能为空',
    identifierNotNull: 'EDO接收方纳税人识别号不能为空',
    paymentNoNotNull: '付款抬头不能为空',
    invoiceTaxNoNotNull: '发票抬头税号不能为空',
    invoiceBankNoNotNull: '发票抬头账号不能为空',
    accountBankNotNull: '开户行不能为空',
    addressNotNull: '地址不能为空',
    inputNum: '请输入数字',
    reservationSuccessful: '预约成功!',
    reservationFailure: '预约失败!',
    cancelReservationSuccess: '取消预约成功!',
    cancelReservationFail: '取消预约失败!',
    lockNotLook: '已锁定的提单不能预约',
    bookedBl: '以下提单号已被预约，不可重复预约！ \n',
    noDeliverableDate: '没有维护换单时间，不能预约',
    edosentstatusNotEdit: '已发送EDO，预约信息不可修改',
    contactCompany: '请先联系船公司放货！',
    payOnSite: '请现场交换单费！',
    bankSlipUploadInstructions: "水单上传说明:",
    uploadCorrectFile: "1) 如果预约时已上传正确水单和介质码，则换单资料只需递送背书提单。",
    noNeedForSlip: "2) 请上传正确水单和介质码文件，否则无法成功预约！",
    increaseEfficiency: "3) 为提高换单效率，银行水单上传格式将限制为PDF/JPG/PNG/BMP/TIFF，除上述文件格式以外内容将限制上传。一次预约多次付款需上传多份文件的客户，烦请合成一份PDF文件，谢谢!",
    invoiceInfo: "4) 如果是第一次申请开票或公司信息更新的需要填写发票相关信息!",
    blExchangeRequirement: '***正本提单换取提货单，需要递交收货人换单委托书***',
    blExchangeNote: '说明:授权客户填写不影响换单预约，但不及时填写会影响提货受理，请及时维护授权客户信息',
    blExchangeStep1: '1) 选择电子提货单，必须在提货前维护与上港受理中心签约的授权客户代码。代码可在',
    blExchangeStep1Part2: '内查询',
    blExchangeStep2: '2) 选择电子提货单，换单时将不再提供纸质提货单',
    blExchangeStep3: '3) 请上传正确水单文件，否则无法成功预约',
    blExchangeStep4: '4) 为提高换单效率，银行水单上传格式将限制为PDF/JPG/PNG/BMP/TIFF，除上述文件格式以外内容将限制上传。一次预约多次付款需上传多份文件的客户，烦请合成一份PDF文件，谢谢！',
    blExchangeStep5: '5) 水单金额需与所预约的单子金额一致，否则机器人将无法开票，并自动取消预约',
    contactInfo: '进口换单 51166938 袁先生 进口操作 51188044、51166906/6928/6934/6954/6956/6957/6958',
    authorizationNote: '说明:授权客户填写不影响换单预约，但不及时填写会影响提货受理，请及时维护授权客户信息',
    alreadyReserved: '{blNo} 已预约的提单不能进行批量预约',
    unpaid: '{blNo} 未付款的提单不能进行批量预约',
    inconsistentNature: '{blNo} 批量预约的提单号提单性质不一致',
    lockedBill: '{blNo} 已锁定的提单不能进行预约',
    paymentAmount: '付款金额',
    invoiceNumber: '发票号码',
    debitNoteNumber: '对账单号码',
    demurrageReceipt: '滞期费水单',
    taxAttachment: '预扣税税单',
    taxFlag: '是否扣预扣税',
    documentType: '换单类型',
    containerGuarantee: '提箱保函',
    authorizationLetter: '授权书',
    insuranceCertificate: '保险证明',
    idCardScan: '身份证扫描件',
    billOfLadingCopy: '提单复印件',
    deliveryOrder: '提货单',
    obl: '正本提单',
    bankGuaranty: '银行保函',
    oblWithBankStamp: '正本提单复印件加盖银行章',
    paymentAccount: '付款账号',
    bankRefNo: '银行参考号码',
    paymentBank: '付款银行',
    phPortSingleSelection: 'PH港口只能选择一条数据进行预约',
    addBtn: '增加',
    delBtn: '删除',
    localFees: '本地费用',
    demurrageFees: '滞期费费用',
    uploadAttachment: '上传文件',
    calInfoBegin1: '修改提箱日期提示',
    calInfoBegin2: '提示!!!',
    calInfoBegin3: '滞期费计算结果: ',
    calDateInfoNotFromDate: 'You are requesting for demurrage calculation for Bill Of Lading No.{blNo} Until {endMoveDate}',
    calDateInfoNotWithFromDate: '您已提交提单号：',
    calAmountToCurrency: '请尽快支付滞期费总金额：',
    calExchangeRate: '汇率: ',
    calConvertedToPHP: '折算PHP总金额：',
    calInfoEnd: '支付完成后，到换单预约历史界面继续提交。',
    from: '的超FREE TIME提箱申请 日期从',
    to: '到',
    infoInputConsigneeName: '请填写收货人姓名',
    infoInputMail: '请填写邮箱',
    infoCheckDocumentType: '请填写请选择换单类型',
    mustUpload: '请上传以下必需文件',
    uploadSuccess: '{fileTypeName} 文件上传成功',
    uploadFail: '{fileTypeName} 文件上传失败',
    mustInputAmount: '请输入付款金额',
    mustInputBdoRefNo: '请输入银行参考号码',
    bdoRefNoMustBeDigits: '最多输入{field}位数字',
    mustCheckFormat: '请输入有效的金额格式（最多两位小数）',
    checkBaseInfo: '{feeTypeName} 第 {index} 行的 {fieldName} 信息不完整，请填写完整',
    checkBankInfo: '{feeTypeName} 第 {index} 行的支付银行信息不完整，支付方式为网银转账时必须选择银行',
    checkPaymentAccountInfo: '{feeTypeName}第{index}行的付款账号信息不完整，支付方式为网银转账时必须填写付款账号',
    checkPaymentFormat: '{feeTypeName}第{index}行的付款金额格式不正确，请输入有效的金额格式（最多两位小数）',
    infoInputLeastFee: '至少保留一条费用记录',
    infoChangePickupDate: '以下集装箱的提箱日期不能早于原始日期: ',
    infoChangePickupDateErrorTitle: '日期错误: ',
    infoChangePickupDateErrorMsg: '{containerNo} 当前设置 {setterDate} 不能早于 {originalDate}',
    documentTypeInfoOBL: '换单类型正本提单和银行保函换单类别时，必须将正本提单原件/银行保函原件和正本提单复印件加盖银行章\n' + '                送至现场方可审核通过',
    documentTypeInfoBG: '换单类型正本提单和银行保函换单类别时，必须将正本提单原件/银行保函原件和正本提单复印件加盖银行章\n' + '                送至现场方可审核通过',
    cannotPrintEdoByPh: '以下提单尚未换单，无法进行批量打印：{blNos}',
    // 提箱日期确认对话框
    pickUpDateConfirmTitle: '提箱日期确认',
    pickUpDateConfirmText: '您计划在 {pickUpDate} 进行提箱',
    pickUpDateConfirmText2: '进行提箱',
    pickUpDateWarning: '请确认提箱日期无误后再进行下一步操作',
    cancelPickUp: '取消',
    confirmPickUp: '确认提箱',
    confirmPickUpCountdown: '确认提箱 ({seconds}s)',
    // 提示消息
    queryDataFailed: '查询数据失败',
    pleaseSelectPickUpDate: '请先选择提箱日期',
    noPickUpDateSelected: '未设置提箱日期',
    pickUpSaveAndCalculateSuccess: '提箱日期保存和滞期费计算完成',
    operationFailed: '操作失败',
    savePickUpAndCalculateFailed: '保存提箱记录和计算滞期费失败',
    pleaseSetPickUpDateFirst: '请先设置提箱日期'
  }
};